var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.landscape)?_c('div',{staticClass:"pe_rotate-device"},[_c('div',{staticClass:"pe_phone"}),_c('div',{staticClass:"pe_message"},[_vm._v(" Please rotate your device. ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }